import { EventInfo } from "framer-motion";
import React from "react";
import { get } from "../../constants/theme";
import Box from "../Box/Box";
import MotionBox from "../Box/MotionBox";
import { Link } from "gatsby";
import { Props } from "./types";
import { useLocation } from "@reach/router";

const LinkWrapper = React.memo(
  ({
    id,
    to,
    children,
    handleHoverStart,
    handleHoverEnds,
    disabled = false,
    ...rest
  }: Props) => {
    const location = useLocation();
    const isThisPage = location.pathname === to;
    const isLink = Boolean(to);

    const hoverStart = React.useCallback(
      (_event: any, _info: EventInfo) => {
        handleHoverStart(id);
      },
      [handleHoverStart, id]
    );

    const hoverEnds = React.useCallback(
      (_event: any, _info: EventInfo) => {
        handleHoverEnds();
      },
      [handleHoverEnds]
    );

    const handleLinkClick = React.useCallback(
      (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (isThisPage) {
          e.preventDefault();
          e.stopPropagation();
          window.location.reload();
        }
      },
      [isThisPage]
    );

    return (
      <MotionBox
        sx={{
          width: "fit-content",
          color: get("palette.text.dark_gold"),
          opacity: disabled ? 0.5 : 1,
        }}
        onHoverStart={hoverStart}
        onHoverEnd={hoverEnds}
        key={id}
        whileHover={{ opacity: 0.6 }}
      >
        <Box
          {...(isLink ? { onClick: handleLinkClick, as: Link, to } : { as: "span" })}
          sx={{
            display: "block",
            fontSize: ["34px", "34px", "34px", "62px"],
            lineHeight: ["48px", "48px", "48px", "68px"],
            fontFamily: "custom_42263",
            fontFeatureSettings: `"liga" 0, "rlig" 0, "dlig" 0, "hlig" 0, "smcp" 0`,
            textRendering: "optimizeLegibility",
            fontSmooth: "antialiased",
            cursor: isLink ? "pointer" : "default",
            textDecoration: "none",
            background: "none",
            pointerEvents: disabled ? "none" : null,
          }}
        >
          {children}
        </Box>
      </MotionBox>
    );
  }
);

export default LinkWrapper;
